import { ThemeContext } from '@/theme/ThemeProvider';
import { useIsMobile } from '@/utils/CalVW';
import { useContext } from 'react';
import styled from 'styled-components';
import MActiveSvg from './MActiveSvg';

const ActiveSvg = () => {
  const { theme } = useContext(ThemeContext);
  const isMobile = useIsMobile();
  const fill = theme.COLORS.greenText;

  if (isMobile) {
    return <MActiveSvg />;
  }

  return (
    <>
      <FirstLayer
        width="100"
        height="100"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M94.9106 48.9352H99.9998C99.7691 36.4026 94.8061 24.4212 86.1075 15.3963L82.5091 18.9948C82.0883 19.4052 81.4146 19.3967 81.0045 18.9761C80.6014 18.5628 80.6014 17.9035 81.0045 17.4904L84.603 13.8919C75.5781 5.19322 63.5967 0.230423 51.0641 -0.000488281V5.08872C51.0641 5.67632 50.5876 6.15283 50 6.15283C49.4124 6.15283 48.9359 5.67632 48.9359 5.08872V-0.000488281C36.4033 0.23021 24.4219 5.19322 15.397 13.8919L18.9955 17.4904C19.4163 17.9008 19.4249 18.5744 19.0146 18.9951C18.6042 19.4159 17.9304 19.4243 17.5096 19.014C17.5033 19.0076 17.4969 19.0012 17.4907 18.9948L13.8923 15.3963C5.19366 24.4212 0.230911 36.4026 0 48.9352H5.08921C5.67681 48.9352 6.15332 49.4117 6.15332 49.9993C6.15332 50.5869 5.67681 51.0634 5.08921 51.0634H0C0.230698 63.596 5.19366 75.5775 13.8923 84.6023L17.4907 81.0038C17.901 80.583 18.5746 80.5743 18.9953 80.9846C19.4163 81.3947 19.4249 82.0685 19.0146 82.4893C19.0084 82.4956 19.0019 82.502 18.9955 82.5082L15.397 86.1068C24.4219 94.8054 36.4033 99.7682 48.9359 99.9991V94.9099C48.9359 94.3223 49.4124 93.8458 50 93.8458C50.5876 93.8458 51.0641 94.3223 51.0641 94.9099V99.9991C63.5967 99.7684 75.5781 94.8054 84.603 86.1068L81.0045 82.5082C80.5837 82.0978 80.5752 81.424 80.9858 81.0033C81.3963 80.5826 82.0698 80.5743 82.4904 80.9846C82.4967 80.9908 82.5031 80.9971 82.5093 81.0035L86.1077 84.6021C94.8063 75.577 99.7691 63.5958 100 51.0632H94.9108C94.3232 51.0632 93.8467 50.5867 93.8467 49.9991C93.8467 49.4115 94.323 48.9352 94.9106 48.9352ZM49.9998 92.2443C26.7059 92.2443 7.75478 73.2932 7.75478 49.9993C7.75478 26.7054 26.7059 7.75429 49.9998 7.75429C73.2937 7.75429 92.2448 26.7054 92.2448 49.9993C92.2448 73.2932 73.2937 92.2443 49.9998 92.2443Z"
          fill={fill}
        />
      </FirstLayer>

      <SecondLayer
        width="82"
        height="82"
        viewBox="0 0 82 82"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M40.9996 0.882812C18.8792 0.882812 0.882812 18.8792 0.882812 40.9996C0.882812 63.12 18.8792 81.1164 40.9996 81.1164C63.12 81.1164 81.1164 63.12 81.1164 40.9996C81.1164 18.8792 63.12 0.882812 40.9996 0.882812ZM40.9996 77.2856C20.9914 77.2856 4.71359 61.0078 4.71359 40.9996C4.71359 20.9914 20.9914 4.71359 40.9996 4.71359C61.0078 4.71359 77.2856 20.9914 77.2856 40.9996C77.2856 61.0078 61.0078 77.2856 40.9996 77.2856Z"
          fill={fill}
        />
      </SecondLayer>

      <ThirdLayer
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M34.9996 0.841797C16.1649 0.841797 0.841797 16.1649 0.841797 34.9996C0.841797 53.8343 16.1649 69.1574 34.9996 69.1574C53.8343 69.1574 69.1574 53.8343 69.1574 34.9996C69.1574 16.1649 53.8343 0.841797 34.9996 0.841797Z"
          fill={fill}
        />
      </ThirdLayer>
    </>
  );
};

export default ActiveSvg;

const FirstLayer = styled.svg`
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
`;

const SecondLayer = styled.svg`
  position: absolute;
  top: 9.5%;
  left: 9.88%;
`;

const ThirdLayer = styled.svg`
  position: absolute;
  left: 15.84%;
  top: 15.44%;
`;
